import "./search-input.scss";
import {ChangeEvent, KeyboardEventHandler} from "react";
import FontBody3 from "../fonts/font-body3/font-body3";
import {FONT_COLOR} from "../fonts/font-props";
import IconDiscard from "../icons/icon-discard/icon-discard";
import IconInfo from "../icons/icon-info/icon-info";
import IconSearch from "../icons/icon-search/icon-search";
import Icon from "../icons/icon/icon";
import RoundLoader, {RoundLoaderType} from "../loaders/round-loader/round-loader";
import {Tooltip} from "../tooltip/tooltip";


interface SearchInputProps {
    value: string;
    onClick: () => void;
    onChange: (input: string) => void;
    searchError?: ISearchInputError;
    isSearching?: boolean;
    tooltip?: React.ReactNode;
    placeholder?: string;
    disabled?: boolean;
}
export interface ISearchInputError {
    message: string;
    type?: SearchInputErrorType;
}
export enum SearchInputErrorType {
    GENERIC = "generic",
}

const SearchInput: React.FC<SearchInputProps> = ({ value, onClick, onChange, tooltip, searchError, placeholder = 'Search', isSearching, disabled = false }) => {
    
    const handleChange = (e: ChangeEvent) => {
        onChange((e.target as HTMLInputElement).value);
    }

    const clearInput = () => {
        onChange('');
    }

    const handleClick = () => {
        if (disabled) {
            return;
        }
        onClick();
    }
        
    const handleEnter: KeyboardEventHandler<HTMLInputElement> = (e) => {
        if (e.key === 'Enter') {
            handleClick();
        }
    }

    return (
        <span className={`search-container${disabled ? ' disabled' : ''}`}>
            <span className="search-upper-container">
                <span className="search-input-container">
                    <input disabled={disabled} value={value} placeholder={placeholder} onKeyPress={handleEnter} onChange={handleChange} />
                    <span className="search-button-container" onClick={handleClick}>
                        <Icon Component={isSearching ? () => <RoundLoader type={RoundLoaderType.Light}/> : IconSearch} />
                    </span>
                    <span className='search-input-x' onClick={clearInput}><Icon Component={()=><IconDiscard color={'var(--color-primary-3-10)'} />} /> </span>
                </span>
                {tooltip && <Tooltip content={tooltip}><Icon Component={IconInfo} /></Tooltip>}
            </span>
                {searchError &&
                    <span className="search-error-container">
                        <FontBody3 color={FONT_COLOR.ACCENT3}>{searchError.message}</FontBody3>
                    </span>
                }
        </span>
    );
};
export default SearchInput;
